<div
  class="message-container"
  [ngClass]="{
    'message-container--error': isErrorMessage,
    'message-container--info': !isErrorMessage || isInfo,
    'message-container--notice': isNotice,
    'message-container--success': isSuccess,
  }"
>
  <div class="row">
    <ng-container *ngIf="isErrorMessage">
      <div class="col-lg-1 col-md-1 col-sm-1 col-4">
        <div class="status-icon">
          <i class="fa fa-exclamation-circle status-icon--md"></i>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isNotice">
      <div class="col-lg-1 col-md-1 col-sm-1 col-4">
        <div class="status-icon">
          <i class="fa fa-exclamation-circle status-icon--md icon-border"></i>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isSuccess">
      <div class="col-lg-1 col-md-1 col-sm-1 col-4">
        <div class="status-icon">
          <i class="fa fa-check-circle status-icon--md icon-border"></i>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isInfo">
      <div class="col-lg-1 col-md-1 col-sm-1 col-4">
        <div class="status-icon">
          <i class="fa fa-info-circle status-icon--md"></i>
        </div>
      </div>
    </ng-container>

    <div class="col-lg-11 col-md-11 col-sm-11 col-8 text-alignment">
      <div class="status-message">
        <span class="status-header">{{ messageTitle }}</span>
        <div class="status-content text-alignment">
          <p class="description">{{ messageBody }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
